import { useRef } from 'react'
import Button, { type ButtonProps } from 'components/button'

interface FileUploadButtonProps extends Omit<ButtonProps, 'onChange'> {
    onChange: (files: File[]) => any
    accept?: string
}

export default ({ onChange, accept, ...props }: FileUploadButtonProps) => {
    const inputRef = useRef<HTMLInputElement>(null)

    const handleFileUpload = (event: any) => {
        onChange(Array.from(event.target.files) as any)
    }

    return (
        <>
            <input
                ref={inputRef}
                onChange={handleFileUpload}
                type="file"
                style={{ display: 'none', visibility: 'hidden' }}
                multiple={true}
                accept={accept}
            />
            <Button
                onPress={() => inputRef.current!.click()}
                style={{ maxWidth: '150px', ...props.style }}
                {...props}
            />
        </>
    )
}
